import {Store} from "pullstate";
import _ from "../../src/_/index";
import indexBy from "underscore/modules/indexBy";
import {UserCouponBookmarkStore, UserEventActivityStore, UserEventTestStore, UserPostBookmarkStore, UserPostFavorStore, UserTokenEntrustStore} from "./Common_Store";
import {filter} from "ionicons/icons";
import {handleExecutor} from "../pages/Utils";
import {Pg_4_4_Store, push_pg_4_2__AddCouponBookmark} from "./Pg_4_Store";

export const Pg_7_1_Store = new Store({});

export const Pg_7_2_Store = new Store({});
export const Pg_7_2_1_Store = new Store({});
export const Pg_7_2_2_Store = new Store({});

export const Pg_7_3_Store = new Store({});
export const Pg_7_3_1_Store = new Store({});

export const Pg_7_4_Store = new Store({});
export const Pg_7_4_1_Store = new Store({});

export const Pg_7_5_Store = new Store({});

export const Pg_7_6_Store = new Store({});



let fetchOption = (postParams) => {
    return {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(postParams) // body data type must match "Content-Type" header
    } as any;
};
//#region 7_1
export const fetch_Pg_7_1 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_1_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const push_pg_7_1__savecard = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_1/savecard`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_7_1_Store.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


//#endregion
export const push_pg_7_1__Delete = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_6_1/delete`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        let state: any = Pg_7_1_Store.getRawState();
        if (!state?.Root?.List_圖片生成) {
            return false;
        }
        Pg_7_1_Store.update(s => {
            let List_圖片生成 = state.Root.List_圖片生成.filter(function (item) {
                if (item === undefined || item.圖片生成Id == postParams.p1)
                    return false;
                return true;
            });
            return Object.assign(s, {
                Root : {
                    ...state.Root,
                    List_圖片生成: List_圖片生成,
                }
            });
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


//#region 7_2
export const fetch_pg_7_2 = async (postParams: {
    p1: string | null //contractId
    p2: boolean | null //isBookmark
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_2`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_2_Store.update(s => { return Object.assign(s, payload) });

        if (payload.Root.Attach_List_會員_Sdgs課程__參加) {
            let keyed = indexBy(payload.Root.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');

            UserEventTestStore.update(s => {
                return Object.assign(s, keyed)
            });
        }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}



export const push_pg_7_2__AddCouponBookmark = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_4_2/addbookmark`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserCouponBookmarkStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


export const push_pg_7_2__RemoveCouponBookmark = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_4_2/removebookmark`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserCouponBookmarkStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}




export const fetch_pg_7_2_1 = async (postParams: {
    p1: string | null //contractBonusId
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_2_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_2_1_Store.update(s => { return Object.assign(s, payload) });

        if (payload.Root.Attach_List_會員_Sdgs課程__參加) {
            let keyed = indexBy(payload.Root.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');

            UserEventTestStore.update(s => {
                return Object.assign(s, keyed)
            });
        }
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const fetch_pg_7_2_2 = async (postParams: {
    p1: string | null //contractBonusId
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_2_2`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_2_2_Store.update(s => { return Object.assign(s, payload) });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const push_pg_7_2_1__joinquiz = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_2_1/joinquiz`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        if (payload.Attach_List_會員_Sdgs課程__參加) {
            let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');

            UserEventTestStore.update(s => {
                return Object.assign(s, keyed)
            });

            delete payload.Attach_List_會員_Sdgs課程__參加;
        }

        Pg_7_2_1_Store.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_7_2_2__competequiz = async (postParams: {
    p1: string,
    p2: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_2_2/competequiz`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        if (payload.Attach_List_會員_Sdgs課程__參加) {
            let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');

            UserEventTestStore.update(s => {
                return Object.assign(s, keyed)
            });

            delete payload.Attach_List_會員_Sdgs課程__參加;
        }

        Pg_7_2_2_Store.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
//#endregion

//#region 7_3
export const fetch_pg_7_3 = async (postParams: {
    p1: string | null //contractId
    p2: boolean | null //isBookmark
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_3`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_3_Store.update(s => { return Object.assign(s, payload) });

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}




export const push_pg_7_3_1_JoinEvent = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_3_1/joinevent`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserEventActivityStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_7_3_1_QuitEvent = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_3_1/quitevent`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserEventActivityStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


export const fetch_pg_7_3_1 = async (postParams: {
    p1: string | null //contractBonusId
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_3_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_3_1_Store.update(s => { return Object.assign(s, payload) });

        if (payload.Root.Attach_List_會員_Sdgs活動__參加) {
            let keyed = indexBy(payload.Root.Attach_List_會員_Sdgs活動__參加, 'Sdgs活動Id');

            UserEventActivityStore.update(s => {
                return Object.assign(s, keyed)
            });
        }

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}
//#endregion


//#region 7_4
export const fetch_pg_7_4 = async (postParams: {
    p1: string | null //contractId
    p2: boolean | null //isBookmark
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_4`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_4_Store.update(s => { return Object.assign(s, payload) });

        if (payload.Root.Attach_List_會員_Product__關注) {
            let keyed = indexBy(payload.Root.Attach_List_會員_Product__關注, 'ProductId');

            UserCouponBookmarkStore.update(s => {
                return Object.assign(s, keyed)
            });
        }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}



export const push_pg_7_4__AddCouponBookmark = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_4_2/addbookmark`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserCouponBookmarkStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


export const push_pg_7_4__RemoveCouponBookmark = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_4_2/removebookmark`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        UserCouponBookmarkStore.update(s => {
            return Object.assign(s, payload)
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const fetch_pg_7_4_1 = async (postParams: {
    p1: string | null //contractBonusId
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_4_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_4_1_Store.update(s => { return Object.assign(s, payload) });

    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const push__pg_7_4_1__buy = async (postParams: {
    p1: string,
    p2: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_7_4_1/buy`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // UserEventJoinStore.update(s => {
        //     return Object.assign(s, payload)
        // });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}


//#endregion


//#region 7_5

export const fetch_Pg_7_5 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_5`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_5_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const push_pg_7_5 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_6_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);

        return {errorObj: null, payload: payload};
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_7_5__Delete = async (postParams: {
    p1: string,
}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_6_1/delete`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        let state: any = Pg_7_5_Store.getRawState();
        if (!state?.Root?.List_圖片生成) {
            return false;
        }
        Pg_7_5_Store.update(s => {
            let List_圖片生成 = state.Root.List_圖片生成.filter(function (item) {
                if (item === undefined || item.圖片生成Id == postParams.p1)
                    return false;
                return true;
            });
            return Object.assign(s, {
                Root : {
                    ...state.Root,
                    List_圖片生成: List_圖片生成,
                }
            });
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

//#endregion



//#region 7_6

export const fetch_Pg_7_6 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_7_6`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_7_6_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}


//#endregion
